import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { makeTitle } from '@/features/wa/title/makeTitle'

export const useDocTitle = (titles: string[] | string) => {
  const { t, i18n } = useTranslation()

  const originalTitleRef = useRef(document.title)

  useEffect(() => {
    const originalTitle = originalTitleRef.current

    const translator = (title: string) => (i18n.exists(title) ? t(title) : title)

    const _titles = Array.isArray(titles) ? titles : [titles]
    document.title = makeTitle(_titles, translator)

    return () => {
      document.title = originalTitle
    }
  }, [i18n, t, titles])
}
